import { TaskList } from '@pages/task/list';

export default function TaskPage() {
  return <TaskList />;
}
